module.exports = __webpack_public_path__ + "static/media/C20-0132_Coffee_Croissant_Mobile_767x845_FR.d91d7333.jpg";